import React, { useState, useMemo } from 'react';
import { useFormContext } from './Provider';
import { Transition } from '@headlessui/react'
import { classNames, has } from '../../Services/helpers';

const MoreFields = ({children, title, fieldNames, startExpanded = null}) => {
    const {formData} = useFormContext();
    const theFieldNames = fieldNames || children.map(child => child.props?.name);

    const startedWithData = useMemo(
        () => theFieldNames.reduce((acc, name) =>  acc || has(formData[name]), false),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [theFieldNames]
    );
    const [expanded, setExpanded] = useState(startExpanded ?? startedWithData);

    const btn = (set) => {
        return <p className="my-3 text-center"
            onClick={() => setExpanded(set)}
        >
            <span className="cursor-pointer text-muted py-1 px-4 border rounded-lg text-sm">
                {set ? `Show ${title?.toLowerCase() ?? 'more fields'}` : `Hide ${title?.toLowerCase() ?? 'more fields'}`}
            </span>
        </p>
    }

    return <>
        <Transition show={expanded}>
            <div className={classNames(
                // Base styles
                'transition ease-in-out duration-500 overflow-hidden max-h-fit',
                // Shared closed styles
                'data-closed:opacity-0 data-closed:max-h-0',
            )}>
                {title && <p className="font-semibold leading-6 text-brand">{title}</p>}
                <div className="flex flex-col gap-y-3">
                    {children}
                </div>
                {btn(false)}
            </div>
        </Transition>
        <Transition show={!expanded}>
            {btn(true)}
        </Transition>
    </>
}

export default MoreFields;
